/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/undefined/ngm-portal-jws/public/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "6v/2");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+kwT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function () {
  function Module() {
    _classCallCheck(this, Module);

    this.init;
  }

  _createClass(Module, [{
    key: 'AppendGameList',
    value: function AppendGameList(arr, callback) {
      var _this = this;

      var result = arr.map(function (v, index) {
        return _this.createGameList(v);
      });
      callback ? callback(result.join('')) : '';
    }
  }, {
    key: 'createGameList',
    value: function createGameList(obj) {
      return '<div class="m-gamelist-item" data-statis="logo_hotword_playlist_po_' + obj.num + '}" type="btn" href="' + obj.url + '">\n  <div class="m-gamelist-item-container">\n    <div class="m-gamelist-item-bg">\n    <img class="lazy" dataimg="' + obj.img + '" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif" />\n    </div>\n    <div class="m-gamelist-item-like">' + obj.like + '</div>\n    <div class="m-gamelist-item-title">' + obj.abstract + '</div>\n  </div>\n  <div class="m-gamelist-item-userinfo">\n    <div class="m-gamelist-item-userinfo-headicon">\n     <img class="lazy" dataimg="' + obj.userIcon + '" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif" >\n    </div>\n    <div class="m-gamelist-item-userinfo-detail">\n      <div class="m-gamelist-item-userinfo-detail-name">' + obj.userName + '</div>\n      <div class="m-gamelist-item-userinfo-detail-level">\n        <div class="m-gamelist-item-userinfo-detail-level-level ' + obj.userLevel + '"></div>\n        <div class="m-gamelist-item-userinfo-detail-level-abstract">' + obj.userAbstract + '</div>\n      </div>\n    </div>\n  </div>\n</div>';
    }
  }]);

  return Module;
}();

module.exports = new Module();

/***/ }),

/***/ "0FLg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestSpecialUa = function () {
  function TestSpecialUa() {
    _classCallCheck(this, TestSpecialUa);
  }

  _createClass(TestSpecialUa, [{
    key: 'isBaidu',
    value: function isBaidu() {
      if (this.ua.indexOf('baidu') > -1) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'isOppo',
    value: function isOppo() {
      if (/oppo/i.test(this.ua)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'ua',
    get: function get() {
      if (window.navigator && window.navigator.userAgent && window.navigator.userAgent) {
        return window.navigator.userAgent;
      } else {
        return 'unkown';
      }
    }
  }]);

  return TestSpecialUa;
}();

module.exports = new TestSpecialUa();

/***/ }),

/***/ "2szZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var lazyLoad = {
  init: function init(ListenDOM) {
    var that = this;
    that.img.srcStore = 'dataimg';
    that.img.class = 'lazy';
    that.img.sensitivity = 50;
    that.img.init(ListenDOM);
  },

  img: {
    trigger: function trigger(ListenDOM) {
      var that = this;
      var eventType = that.isPhone && 'touchend' || 'scroll';
      that.imglist = $('img.' + that.class + '');
      $(ListenDOM || window).trigger(eventType);
    },
    init: function init(ListenDOM) {
      var that = this;


      $(ListenDOM || window).on('scroll', function () {
        that.changeimg();
      });

      that.trigger(ListenDOM);
      that.isload = !0;
    },
    changeimg: function changeimg() {
      var that = this;

      function loadYesOrno(img) {
        var windowPageYOffset = window.pageYOffset;
        var windowPageYOffsetAddHeight = window.pageYOffset + window.innerHeight;
        var imgOffsetTop = img.offset().top;
        return imgOffsetTop >= windowPageYOffset && imgOffsetTop - that.sensitivity <= windowPageYOffsetAddHeight;
      }

      function loadImg(img, index) {
        var imgUrl = img.attr(that.srcStore);
        var imgLazy = img.attr('src');
        img.attr('src', imgUrl);
        img[0].onload || (img[0].onload = function () {
          $(this).removeClass(that.class).removeAttr(that.srcStore), that.imglist[index] = null, this.onerror = this.onload = null;
        }, img[0].onerror = function () {
          this.src = imgLazy, $(this).removeClass(that.class).removeAttr(that.srcStore), that.imglist[index] = null, this.onerror = this.onload = null;
        });
      }

      that.imglist.each(function (index, val) {
        if (!val) return;
        var img = $(val);
        if (!loadYesOrno(img)) return;
        if (img.height() == 0 && img.width() == 0) return;
        var aa = img.attr(that.srcStore);
        if (!img.attr(that.srcStore)) return;
        loadImg(img, index);
      });
    }
  },
  forceUpdate: function forceUpdate() {
    lazyLoad.img.trigger();
    lazyLoad.img.changeimg();
  }
};
lazyLoad.init();

module.exports = {
  setInit: function setInit(ListenDOM) {
    lazyLoad.init(ListenDOM);
  },

  forceUpdate: lazyLoad.forceUpdate
};

/***/ }),

/***/ "6v/2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__("jChq");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var lazy = __webpack_require__("2szZ");
var TestUa = __webpack_require__("0FLg");

__webpack_require__("vIqV")(function () {
  lazy.setInit();
}, { scrollLoad: true, initScroll: false });

__webpack_require__("cRQd");

var Cards = __webpack_require__("kORv");
var GameList = __webpack_require__("+kwT");

var currentHotword = $('#currentHotword').val();
var AgStat = __webpack_require__("8fE/");
var ag_stat = new AgStat('hotword', {
  ag_field: 'hotword',
  ag_value: currentHotword
});

var Module = function () {
  function Module() {
    _classCallCheck(this, Module);

    lazy.setInit();
    var xlyx = __webpack_require__("GgL9");
    xlyx.callback = function () {};
    this.renderInfo = {
      gameName: null,
      gameId: null,
      fileSize: null,
      instruction: null,
      logo: '',
      randomGameId: this.getRandom(6),
      randomPickId: this.getRandom(3)
    };
    this.insertDom();
    this.cardsData = this._cardsData;
    this.gameListData = this._gameListData;
    this.UnfoldLink();
    this.HeaderDetailToggleMore();
    this.DownloadPullUp();
    this.baiduChDownloadHandle();
    this.v21DownloadHandle();
    this.v22DownloadHandle();
    this.UnfoldCards();
    this.UnfoldGameList();
    this.ClickStat();
    this.FixMorePlayItem();

    var topicType = $('body').data('topictype');

    var Popover = __webpack_require__("AE1G");
    var popover = new Popover({
      container: '#show-popover',
      to: '.bottom-activity-icon',
      time: 3,
      etag: 1 });
    popover.init();
  }

  _createClass(Module, [{
    key: 'DownloadPullUp',
    value: function DownloadPullUp(ismore) {
      var _this2 = this;

      var $target = null;
      if (ismore === 1) {
        $target = $('.JS_ng_down[data-more="1"]');
      } else {
        $target = $('.JS_ng_down');
      }
      $target.on('click', function (e) {
        var gameId = $(e.target).data('gameId');
        var urlCode = $('input[data-url-code]').data('urlCode');
        _this2.PullUp(gameId, 'ugt-web-hotkeyword-' + urlCode + '-' + gameId);
      });
    }
  }, {
    key: 'getRandom',
    value: function getRandom(count) {
      var str = '';
      for (var i = 0; i < count; i++) {
        str += Math.floor(Math.random() * 10);
      }
      return str;
    }
  }, {
    key: 'downloadThirdType',
    value: function downloadThirdType(gameId, pullUpFrom) {
      var _this3 = this;

      var _this = this;
      $.ajax({
        type: 'GET',
        url: '//a.9game.cn/tpl/pc2/ajaxinfo/ajax_download_info.html',
        timeout: 4000,
        data: { gi: gameId, pi: 2 },
        success: function success(res) {
          res = JSON.parse(res);
          if (res.toyBlockGameType === 1) {
            _this.doPullUp(gameId, pullUpFrom);
            return;
          }
          if (res.downloadThirdType === 1) {
            _this.getGameInfo(gameId);
          } else {
            _this3.planABtestForDownload(gameId, pullUpFrom);
          }
        },
        error: function error(err) {
          console.log(err);
        }
      });
    }
  }, {
    key: 'PullUp',
    value: function PullUp(gameId, pullUpFrom) {
      this.downloadThirdType(gameId, pullUpFrom);
    }
  }, {
    key: 'doPullUp',
    value: function doPullUp(gameId, pullUpFrom) {
      var ch = $('input[data-url-code]').data('ch');
      var wakeUpUrlQuery = $('#__WAKE_UP_URL_QUERY').val() || '';
      var params = {
        pageType: 'game_detail',
        opt: 'download',
        gameId: gameId,
        ch: ch,
        checkTime: 200,
        pullUpFrom: pullUpFrom };
      if (TestUa.isOppo()) {
        var url = window.NineGameClientPullUp.getSchemeDownloadUrl(params);
        if (wakeUpUrlQuery) {
          if (url.indexOf('?') > -1) {
            url += wakeUpUrlQuery ? '&' + wakeUpUrlQuery : '';
          } else {
            url += wakeUpUrlQuery ? '?' + wakeUpUrlQuery : '';
          }
        }
        console.log('d ===>', url);
        window.location.href = url;
        return;
      }
      NineGameClientPullUp.wakeup(_extends({}, params, { auto: false }), function (error, update, result) {
        if (!error) {
          console.log('拉起成功');
        } else {
          var url = result;
          if (wakeUpUrlQuery) {
            if (url.indexOf('?') > -1) {
              url += wakeUpUrlQuery ? '&' + wakeUpUrlQuery : '';
            } else {
              url += wakeUpUrlQuery ? '?' + wakeUpUrlQuery : '';
            }
          }
          console.log('d ===>', url);
          window.location.href = url;
        }
      });
    }
  }, {
    key: 'planABtestForDownload',
    value: function planABtestForDownload(gameId, pullUpFrom) {
      var _this4 = this;

      this.pureGetGameInfo(gameId).then(function (e) {
        var _JSON$parse = JSON.parse(e),
            ppdownloanUrl = _JSON$parse.ppdownloanUrl;

        if (ppdownloanUrl) {
          window.location.href = ppdownloanUrl;
        } else {
          _this4.doPullUp(gameId, pullUpFrom);
        }
      });
    }
  }, {
    key: 'pureGetGameInfo',
    value: function pureGetGameInfo(gameId) {
      var topicId = $('[data-topicId]').data('topicid') || '';
      var promise = new Promise(function (resolve, reject) {
        $.ajax({
          type: 'GET',
          url: '//a.9game.cn/tpl/android_new/common/gameinfo_ajax_pp.html',
          timeout: 4000,
          data: {
            gameId: gameId,
            topicId: topicId
          },
          success: function success(res) {
            resolve(res);
          },
          error: function error(err) {
            reject(err);
          }
        });
      });
      return promise;
    }
  }, {
    key: 'getGameInfo',
    value: function getGameInfo(gameid) {
      var _this5 = this;

      var _this = this;
      var topicId = $('[data-topicId]').data('topicid') || '';
      $.ajax({
        type: 'GET',
        url: '//a.9game.cn/tpl/android_new/common/gameinfo_ajax_pp.html',
        timeout: 4000,
        data: {
          gameId: gameid,
          topicId: topicId
        },
        success: function success(res) {
          res = JSON.parse(res);
          _this.renderInfo.gameId = res.gameId;
          _this5.renderInfo.randomGameId = _this5.getRandom(6);
          _this5.renderInfo.randomPickId = _this5.getRandom(3);
          $('.download-alert .gameinfo-wrap .game-name').text(res.gameName);
          $('.download-alert .content .game-name-span').text(res.gameName);
          var smallLogo = 'https://image.9game.cn' + res.logo;
          $('.download-alert .gameinfo-wrap .game-icon').attr('src', smallLogo);
          $('.download-alert .gameinfo-wrap .game-size').text(res.fileSize);
          $('.download-alert .gameinfo-wrap .game-pulisher-wrap').text(res.instruction);
          $('.download-game, .report').data('gameId', gameid);
          $('.download-alert').toggle(true);
          $('.download-game').data('ppDownloadurl', res.ppdownloanUrl);
        },
        error: function error(err) {
          console.log(err);
        }
      });
    }
  }, {
    key: 'insertDom',
    value: function insertDom() {
      var _this6 = this;

      var _this = this;
      var html = ' <div class="download-alert" style="display:none">\n                    <div class="download-container">\n                      <div class="header">\n                      <span class="title">\u7B2C\u4E09\u65B9\u4E0B\u8F7D</span><img src="https://image.9game.cn/s/uae/g/0h/portal/image/download-close.png" alt="" class="download-close">\n                      </div>\n                      <div class="content">\n                        <div class="tips">\u5728dbcloud.top\u4E0A\u641C\u7D22\u300A<span class="game-name-span">' + this.renderInfo.gameName + '</span>\u300B\u7684\u7ED3\u679C</div>\n                        <div class="address-wrap">\n                        <input class="address" value="http://dbcloud.top/#/dl?game_id=' + this.renderInfo.randomGameId + '&pack_id=' + this.renderInfo.randomPickId + '">\n                        </div>\n                        <div class="gameinfo-wrap">\n                          <img src="' + this.renderInfo.logo + '" alt="" class="game-icon">\n                          <div class="game-detail">\n                            <p class="game-name">' + this.renderInfo.gameName + '</p>\n                            <p class="game-size">' + this.renderInfo.fileSize + '</p>\n                            <p class="game-pulisher-wrap">' + this.renderInfo.instruction + '</p>\n                          </div>\n                          <div class="download-game">\n                                \u4E0B\u8F7D\n                          </div>\n                        </div>\n                        <div class="footer">\n                        \u4E0B\u8F7D\u8D44\u6E90\u7531\u7B2C\u4E09\u65B9(\u76EE\u524D\u4E3Adpcloud.top)\u63D0\u4F9B\uFF0C\u82E5\u8BE5\u8D44\u6E90\u8FDD\u53CD\u5F53\u5730\u89C4\u5219\u6216\u4FB5\u72AF\u4E86\u4F60\u7684\u5408\u6CD5\u6743\u5229\uFF0C\u8BF7\u53CA\u65F6<span class="report">\u4E3E\u62A5</span>\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u4F60\u8054\u7CFB\u5E76\u5904\u7406\u76F8\u5173\u95EE\u9898\u3002\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class="report-alert" style="display:none">\n                    <div class="report-container">\n                      <div class="header">\n                        <span class="title">\u4E3E\u62A5\u6E38\u620F</span><img src="https://image.9game.cn/s/uae/g/0h/portal/image/download-close.png" alt="" class="report-close">\n                      </div>\n                      <div class="content">\n                        <div class="tips">\u82E5\u8BE5\u8D44\u6E90\u8FDD\u53CD\u5F53\u5730\u89C4\u5219\u6216\u4FB5\u72AF\u4E86\u4F60\u7684\u5408\u6CD5\u6743\u5229\uFF0C\u8BF7\u4E3E\u62A5\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u4F60\u8054\u7CFB\u5E76\u5904\u7406\u76F8\u5173\u95EE\u9898\u3002</div>\n                        <div class="report-content-wrap">\n                        <textarea class="report-content" placeholder="\u8F93\u5165\u8865\u5145\u8BF4\u660E"></textarea>\n                        </div>\n                      </div>\n                      <div class="footer">\n                        <div class="report-cancal">\u53D6\u6D88</div>\n                        <div class="report-comfire">\u786E\u5B9A</div>\n                      </div>\n                    </div>\n                  </div>';
      $('body').append(html);

      $('.download-close').on('click', function () {
        $('.download-alert').toggle(false);
      });

      $('.report').on('click', function (e) {
        $('.download-alert').toggle(false);
        $('.report-alert').toggle(true);
        var gameId = $(e.target).data('gameId');
      });

      $('.report-cancal,.report-close,.report-comfire').on('click', function () {
        $('.download-alert').toggle(true);
        $('.report-alert').toggle(false);
      });
      $('.report-comfire').on('click', function () {
        $('.download-alert').toggle(true);
        $('.report-alert').toggle(false);
        $('.report-content').val('');
      });

      $('.download-game').on('click', function (e) {
        var gameId = $(e.target).data('gameId');

        var urlCode = $('input[data-url-code]').data('urlCode');
        var ppDownloadurl = $('.download-game').data('ppDownloadurl');
        if (ppDownloadurl) {
          window.location.href = ppDownloadurl;
        } else {
          _this6.doPullUp(gameId, 'ugt-web-hotkeyword-' + urlCode + '-' + gameId);
        }
      });
    }
  }, {
    key: 'FixMorePlayItem',
    value: function FixMorePlayItem() {
      var tempWidth = 0;
      var $root = $('.more-player-played');
      var $liMap = $root.find('li');
      var totalWidth = $root.find('ul').width();
      var widthMap = $root.find('li').map(function (index, e) {
        return $(e).width() + 30;
      });
      widthMap.forEach(function (e, i) {
        if (tempWidth + e > totalWidth) {
          if (totalWidth - tempWidth < 80) {
            tempWidth = e;
          } else {
            $liMap.eq(i).width(totalWidth - tempWidth);
            tempWidth = 0;
          }
        } else {
          tempWidth += e;
        }
      });
    }
  }, {
    key: 'UnfoldCards',
    value: function UnfoldCards() {
      var _this7 = this;

      var that = this;
      $('.main-game-more').on('click', function (e) {
        var arr = _this7.cardsData.splice(0, 10);
        Cards.AppendCards(arr, function (html) {
          $(e.target).before(html);
          lazy.setInit();
          var xlyx = __webpack_require__("GgL9");
          that.DownloadPullUp(1);
          that.baiduChDownloadHandle(1);
          that.v21DownloadHandle(1);
          that.v22DownloadHandle(1);
          xlyx.callback = function () {
            $('.game-download.count-download').attr('href', null).attr('btn', null).on('click', function (e) {
              var gameId = $(e.target).closest('.game-list-item.count-list-item').data('gameId');
              var urlCode = $('input[data-url-code]').data('urlCode');
              that.planABtestForDownload(gameId, 'ugt-web-hotkeyword-xlyx-' + urlCode + '-' + gameId);
            });
          };
        });
        if (_this7.cardsData.length === 0) {
          $(e.target).remove();
        }
      });
    }
  }, {
    key: 'UnfoldGameList',
    value: function UnfoldGameList() {
      var _this8 = this;

      $('.game-list-more').on('click', function (e) {
        var arr = _this8.gameListData.splice(0, 4);
        GameList.AppendGameList(arr, function (html) {
          $(e.target).parent().find('.game-list-container').append(html);
          lazy.setInit();
        });
        if (_this8.gameListData.length === 0) {
          $(e.target).remove();
        }
      });
    }
  }, {
    key: 'UnfoldLink',
    value: function UnfoldLink() {
      $('.p-m-nav-friend-link .unfold-button').on('click', function () {
        $('.p-m-nav-friend-link .friend-link').addClass('unfold-friend-link');
        $('.p-m-nav-friend-link .unfold-button').addClass('hide-unfold-button');
      });
    }
  }, {
    key: 'HeaderDetailToggleMore',
    value: function HeaderDetailToggleMore() {
      var HeaderDetail = $('.header-detail');
      var toggle = $('<div class="detail-more">展开</div>');
      var toggleText = HeaderDetail.text();
      if (!HeaderDetail.data('content')) return;
      HeaderDetail.append(toggle);
      toggle.on('click', function (e) {
        $(e.target).text(function (index, old) {
          if (old === '展开') {
            HeaderDetail.text(HeaderDetail.data('content'));
            HeaderDetail.append(toggle);
            return '收起';
          } else {
            HeaderDetail.text(toggleText);
            HeaderDetail.append(toggle);
            return '展开';
          }
        });
      });
    }
  }, {
    key: 'ClickStat',
    value: function ClickStat() {
      $('body').on('click', function (e) {
        if ($(e.target).hasClass('download')) {
          return;
        }
        var target = $(e.target).attr('class') || $(e.target).text() || $(e.target).parent().attr('class');
      }, true);
    }
  }, {
    key: 'baiduChDownloadHandle',
    value: function baiduChDownloadHandle(ismore) {
      var that = this;
      var $downTarget = null;
      var $toggleTarget = null;
      if (ismore === 1) {
        $downTarget = $('.JS_bd_down[data-more="1"]');
        $toggleTarget = $('.JS_bd_toggle[data-more="1"]');
      } else {
        $downTarget = $('.JS_bd_down');
        $toggleTarget = $('.JS_bd_toggle');
      }
      $downTarget.on('click', function (e) {
        var ishigh = parseInt($(this).data('ishigh'), 10);
        if (ishigh === 1) {
          var gameId = $(this).data('gameId');
          var urlCode = $('input[data-url-code]').data('urlCode');
          that.PullUp(gameId, 'ugt-web-hotkeyword-' + urlCode + '-' + gameId);
        } else {
          var url = $(this).data('url');
          if (url.indexOf('http') === -1) {
            window.location.href = 'https://a.9game.cn' + url;
          } else {
            window.location.href = url;
          }
        }
      });

      $toggleTarget.on('click', function (e) {
        var $selbtn = $(this).find('.select-btn');
        $selbtn.toggleClass('select');
        if ($selbtn.hasClass('select')) {
          $(this).parent().find('.JS_bd_down').removeClass('hide');
          $(this).parent().find('.JS_REALNAME_DOWNLOAD').addClass('hide');
        } else {
          $(this).parent().find('.JS_bd_down').addClass('hide');
          $(this).parent().find('.JS_REALNAME_DOWNLOAD').removeClass('hide');
        }
      });
    }
  }, {
    key: 'v21DownloadHandle',
    value: function v21DownloadHandle(ismore) {
      var that = this;
      var $downTarget = null;
      var $toggleTarget = null;
      if (ismore === 1) {
        $downTarget = $('.JS_v21_down[data-more="1"]');
        $toggleTarget = $('.JS_v21_toggle[data-more="1"]');
      } else {
        $downTarget = $('.JS_v21_down');
        $toggleTarget = $('.JS_v21_toggle');
      }
      $downTarget.on('click', function (e) {
        var ishigh = parseInt($(this).data('ishigh'), 10);
        if (ishigh === 1) {
          var gameId = $(this).data('gameId');
          var urlCode = $('input[data-url-code]').data('urlCode');
          that.PullUp(gameId, 'ugt-web-hotkeyword-' + urlCode + '-' + gameId);
        } else {
          var url = $(this).data('url');
          if (url.indexOf('http') === -1) {
            window.location.href = 'https://a.9game.cn' + url;
          } else {
            window.location.href = url;
          }
        }
      });

      $toggleTarget.on('click', function (e) {
        var $selbtn = $(this).find('.select-btn');
        $selbtn.toggleClass('select');
        $(this).find('.text').toggleClass('select');
        if ($selbtn.hasClass('select')) {
          var btnTxt = $(this).parent().find('.txt').data('htxt');
          $(this).parent().find('.JS_v21_down').data('ishigh', '1').removeClass('normal');
          $(this).parent().find('.txt').text(btnTxt);
          $(this).parent().find('.JS_ani').show();
        } else {
          var _btnTxt = $(this).parent().find('.txt').data('ntxt');
          $(this).parent().find('.JS_v21_down').data('ishigh', '0').addClass('normal');
          $(this).parent().find('.txt').text(_btnTxt);
          $(this).parent().find('.JS_ani').hide();
        }
      });
    }
  }, {
    key: 'v22DownloadHandle',
    value: function v22DownloadHandle(ismore) {
      var that = this;
      var $downTarget = null;
      var $toggleTarget = null;
      if (ismore === 1) {
        $downTarget = $('.JS_v22_down[data-more="1"]');
        $toggleTarget = $('.JS_v22_toggle[data-more="1"]');
      } else {
        $downTarget = $('.JS_v22_down');
        $toggleTarget = $('.JS_v22_toggle');
      }
      $downTarget.on('click', function (e) {
        var ishigh = parseInt($(this).data('ishigh'), 10);
        if (ishigh === 1) {
          var gameId = $(this).data('gameId');
          var urlCode = $('input[data-url-code]').data('urlCode');
          that.PullUp(gameId, 'ugt-web-hotkeyword-' + urlCode + '-' + gameId);
        } else {
          var url = $(this).data('url');
          if (url.indexOf('http') === -1) {
            window.location.href = 'https://a.9game.cn' + url;
          } else {
            window.location.href = url;
          }
        }
      });

      $toggleTarget.on('click', function (e) {
        var $selbtn = $(this).find('.select-btn');
        $selbtn.toggleClass('select');
        if ($selbtn.hasClass('select')) {
          var btnTxt = $(this).parent().find('.JS_v22_down').data('htxt');
          var tipsTxt = $(this).find('.text').data('htxt');
          $(this).parent().find('.JS_v22_down').data('ishigh', '1').text(btnTxt).removeClass('normal');
          $(this).find('.text').text(tipsTxt);
          $(this).parents('.v22_mgameitem').find('.game-gifts').addClass('o').removeClass('g');
        } else {
          var _btnTxt2 = $(this).parent().find('.JS_v22_down').data('ntxt');
          var _tipsTxt = $(this).find('.text').data('ntxt');
          $(this).parent().find('.JS_v22_down').data('ishigh', '0').text(_btnTxt2).addClass('normal');
          $(this).find('.text').text(_tipsTxt);
          $(this).parents('.v22_mgameitem').find('.game-gifts').addClass('g').removeClass('o');
        }
      });
    }
  }, {
    key: '_gameListData',
    get: function get() {
      var $cardsData = $('input[data-game-list-id]');
      var arr = [];
      $cardsData.forEach(function (e, index) {
        var $e = $(e);
        if (!$e.data('gameListId')) return;
        var data = {};
        data.index = index;
        data.num = $e.data('index');
        data.gameListId = $e.data('gameListId');
        data.userName = $e.data('userName');
        data.userAbstract = $e.data('userAbstract');
        data.userLevel = $e.data('userLevel');
        data.userIcon = $e.data('userIcon');
        data.like = $e.data('like');
        data.abstract = $e.data('abstract');
        data.url = $e.data('url');
        data.img = $e.data('img');
        arr.push(data);
      });
      return arr;
    }
  }, {
    key: '_cardsData',
    get: function get() {
      var $cardsData = $('input[data-card-type]');
      var arr = [];
      $cardsData.forEach(function (e, index) {
        var $e = $(e);
        if (!$e.data('cardType')) return;
        var data = {};
        data.index = index;
        data.num = $e.data('index');
        data.cardType = $e.data('cardType');
        data.adAbstract = $e.data('adAbstract');
        data.userName = $e.data('userName');
        data.userAbstract = $e.data('userAbstract');
        data.userLevel = $e.data('userLevel');
        data.userIcon = $e.data('userIcon');
        data.gameId = $e.data('gameId');
        data.gameName = $e.data('name');
        data.gameCategory = $e.data('category');
        data.gameSize = $e.data('size');
        data.gameScore = $e.data('score');
        data.gameAbstract = $e.data('abstract');
        data.gameUrl = $e.data('url');
        data.zoneHref = $e.data('zoneHref');
        data.gameIcon = $e.data('icon');
        data.gameDesc = $e.data('desc');
        data.operationstatus = $e.data('operationstatus');
        data.haspack = $e.data('haspack');
        data.gameKeywords = $e.data('keywords') ? $e.data('keywords').split(',') : [];
        data.gameImgs = $e.data('imgs') ? $e.data('imgs').split('|') : [];
        data.videoPlay = $e.data('videoPlay');
        data.gameCategoryUrl = $e.data('categoryUrl');
        data.gameKeywordsUrl = $e.data('keywordsUrls') ? $e.data('keywordsUrls').split(',') : [];
        arr.push(data);
      });
      return arr;
    }
  }, {
    key: 'isTestA',
    get: function get() {
      var sid = $('[data-sid]').data('sid') || '';
      return !!(Number.parseInt(sid[sid.length - 1], 16) % 2);
    }
  }, {
    key: 'isTestB',
    get: function get() {
      var sid = $('[data-sid]').data('sid') || '';
      return !(Number.parseInt(sid[sid.length - 1], 16) % 2);
    }
  }]);

  return Module;
}();

new Module();

/***/ }),

/***/ "8fE/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  var cb = fn;
  var timerId = null;

  function debounced() {
    var ctx = this;
    var args = arguments;
    clearTimeout(timerId);
    timerId = setTimeout(function () {
      cb.apply(ctx, args);
    }, delay);
  }
  return debounced;
}

function throttle(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

  var cb = fn;
  var timerId = null;
  var firstInvoke = true;
  function throttled() {
    var ctx = this;
    var args = arguments;

    if (firstInvoke) {
      cb.apply(ctx, args);
      firstInvoke = false;
      return;
    }

    if (timerId) {
      return;
    }

    timerId = setTimeout(function () {
      clearTimeout(timerId);
      timerId = null;

      cb.apply(ctx, args);
    }, delay);
  }
  return throttled;
}

function isArray(it) {
  return Object.prototype.toString.call(it) === '[object Array]';
}

var AgStat = function () {
  function AgStat(page, options, opts) {
    _classCallCheck(this, AgStat);

    if (!page) {
      console.error('[constructor]初始化时，页面打点基础页面别称不能为空');
      return;
    }
    this.page = page;
    this.basestatinfo = _extends({
      ag_module: page + '_index'
    }, options);
    this.scrollListener = $(window);
    this.ExplorePortalEleMap = {};
    this.initBindElementClick();
    this.initBindElementExplore();
    this.sendPortalAdUrl = '/stat/report/new/';

    this.KEY_WHITELIST = ['ag_module', 'ag_ct', 'action', 'ag_field', 'ag_value', 'ag_extend', 'ag_a1', 'ag_a2', 'ag_a3', 'ag_a4', 'ag_a5', 'ag_a6', 'ag_a7', 'ag_a8', 'ag_a9', 'ag_a10', 'ag_a11', 'ag_a12', 'ag_a13', 'ag_a14', 'zzjs', 'zxbj', 'submit_remark', 'audit_person'];
    this.TYPES = ['expose', 'click', 'quick_down', 'down', 'data'];
    this.pageStartTime = Date.now();
    this.hiddenTime = 0;
    this.hiddenStartTime = 0;
    this.init(opts);
  }

  _createClass(AgStat, [{
    key: 'init',
    value: function init(opts) {
      var _this = this;

      window.GLOBAL_AgStat = this;
      window.addEventListener('load', function () {
        if (opts && opts.CloseStatTime) {
          console.log('[关闭页面统计] heartStat');
          return;
        }
        _this.pageStartTime = Date.now();
        setTimeout(function () {
          var performance = window.performance || window.msPerformance || window.webkitPerformance;
          if (performance) {
            var timing = performance.timing;
            _this.customStatPortal({
              ag_extend: 'perf',
              ag_a1: timing.responseEnd - timing.fetchStart,
              ag_a2: timing.domInteractive - timing.fetchStart,
              ag_a3: timing.domContentLoadedEventEnd - timing.fetchStart,
              ag_a4: timing.loadEventStart - timing.fetchStart,
              ag_a5: timing.domainLookupEnd - timing.domainLookupStart,
              ag_a6: timing.connectEnd - timing.connectStart,
              ag_a7: timing.responseStart - timing.requestStart,
              ag_a8: timing.responseEnd - timing.responseStart,
              ag_a9: timing.domInteractive - timing.responseEnd,
              ag_a10: timing.loadEventStart - timing.domContentLoadedEventEnd }, 'data');
          } else {
            _this.customStatPortal({
              ag_extend: 'noperf'
            }, 'data');
          }
        }, 0);
        var num = 0;
        var heartStat = function heartStat() {
          _this.customStatPortal({
            ag_extend: 'staytime',
            ag_a1: ++num
          }, 'data');
        };
        var timer = setInterval(heartStat, 15000);
        window.addEventListener('visibilitychange', function (e) {
          if (document.visibilityState && document.visibilityState === 'hidden') {
            _this.hiddenStartTime = Date.now();

            clearInterval(timer);
          } else if (document.visibilityState && document.visibilityState === 'visible') {
            if (_this.hiddenStartTime > 0) {
              _this.hiddenTime = Date.now() - _this.hiddenStartTime;

              timer = setInterval(heartStat, 15000);
            }
          }
        });
      }, false);
    }
  }, {
    key: 'handleStat',
    value: function handleStat(stat, type) {
      var reportStat = _extends({
        ag_ct: type
      }, this.basestatinfo);
      if (type === 'expose' || type === 'click') {
        reportStat.action = this.page + '_' + type;
      } else if (type === 'quick_down' || type === 'down') {
        reportStat.action = this.page + '_down';
      } else if (type === 'data') {
        reportStat.action = this.page + '_data';
      }
      if (typeof stat === 'string') {
        var array = stat.split(';');
        array.forEach(function (element) {
          var tempInfo = element.split(':');
          reportStat[tempInfo[0]] = tempInfo[1];
        });
      } else if ((typeof stat === 'undefined' ? 'undefined' : _typeof(stat)) === 'object') {
        reportStat = _extends({}, reportStat, stat);
      }
      return reportStat;
    }
  }, {
    key: 'customStatPortal',
    value: function customStatPortal(stat, type) {
      if (Object.prototype.toString.call(stat) !== '[object Object]') {
        console.error('[customStatPortal]中stat仅支持对象类型');
        return;
      }
      var hasType = this.TYPES.find(function (v) {
        return v === type;
      });
      if (!hasType) {
        console.error('[customStatPortal]中type必须为expose、click、quick_down、down、data中的一种');
        return;
      }
      var statInfo = this.handleStat(stat, type);
      this.StatPortal(statInfo);
    }
  }, {
    key: 'StatPortal',
    value: function StatPortal(statInfo) {
      if (!statInfo.action) {
        console.warn('[SendToPortal]:action不能为空');
        return;
      }

      this.SendToPortal(_extends({}, statInfo, {
        ag_url: window.location.pathname + window.location.search,
        ag_a14: Date.now() - this.pageStartTime - this.hiddenTime }));
    }
  }, {
    key: 'StatPortalV2',
    value: function StatPortalV2(statInfos) {
      var _this2 = this;

      if (this.IsSpider()) return;
      if (typeof $ === 'undefined') {
        console.warn('[StatPortalV2]:缺少"$"依赖,ajax上报门户失败');
        return;
      }

      if (!isArray(statInfos)) {
        console.warn('[StatPortalV2]:statInfos必须是数组');
        return;
      }

      var stats = '';
      statInfos.forEach(function (item) {
        if (!item.action) {
          console.warn('[StatPortalV2]:action不能为空');
          return;
        }
        var temp = '';
        for (var i in item) {
          if (typeof item[i] !== 'undefined') {
            temp += i + ':' + item[i] + '`';
          }
        }
        temp += 'ag_url:' + (window.location.pathname + window.location.search) + '`';
        temp += 'ag_a14:' + (Date.now() - _this2.pageStartTime - _this2.hiddenTime) + '`';
        stats += temp.substring(0, temp.length - 1) + '####';
      });

      var data = {
        logs: stats.substring(0, stats.length - 4)
      };

      window.setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: '/stat/report/list/',
          data: data,
          timeout: 4000,
          success: function success(data) {},
          error: function error(err) {}
        });
      }, 0);
    }
  }, {
    key: 'isElementVisible',
    value: function isElementVisible(element, wrapper) {
      var e = element;
      if (!e || typeof document === 'undefined') {
        return false;
      }

      var wrapperWidth = void 0;
      var wrapperHeight = void 0;
      var wrapperTop = 0;
      var wrapperLeft = 0;
      wrapper = wrapper || window;

      if (wrapper === window) {
        wrapperWidth = window.innerWidth || document.documentElement.clientWidth;
        wrapperHeight = window.innerHeight || document.documentElement.clientHeight;
      } else {
        var wrapperRect = wrapper.getBoundingClientRect();
        wrapperTop = wrapperRect.top;
        wrapperLeft = wrapperRect.left;
        wrapperWidth = wrapperRect.width;
        wrapperHeight = wrapperRect.height;
      }

      var rect = e.getBoundingClientRect();
      var elementTop = rect.top - wrapperTop;
      var elementLeft = rect.left - wrapperLeft;
      var elementWidth = rect.width;
      var elementOffsetHeight = e.offsetHeight;
      var elementOffsetLeft = elementLeft + elementWidth / 2;

      if (rect.width === 0 && rect.height === 0) {
        return false;
      }

      if (elementOffsetLeft < wrapperWidth && elementOffsetLeft >= 0) {
        if (elementTop >= 0) {
          if (elementTop + 8 < wrapperHeight) {
            return true;
          }
        } else if (Math.abs(elementTop) + 8 < elementOffsetHeight) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'doExploreV2',
    value: function doExploreV2() {
      var _this3 = this;

      var deletePortalIndex = [];
      var batchUploadStats = [];
      for (var i in this.ExplorePortalEleMap) {
        if (this.isElementVisible($('[ag-expose=\'' + i + '\']')[0])) {
          deletePortalIndex.push(i);
          batchUploadStats.push(this.ExplorePortalEleMap[i].stat);
        }
      }
      if (batchUploadStats.length > 0) {
        this.StatPortalV2(batchUploadStats);
      }
      deletePortalIndex.forEach(function (e) {
        delete _this3.ExplorePortalEleMap[e];
      });
    }
  }, {
    key: 'enforceDoExplore',
    value: function enforceDoExplore(exposeStat) {
      if (this.ExplorePortalEleMap[exposeStat]) {
        this.StatPortal(this.ExplorePortalEleMap[exposeStat].stat);
        delete this.ExplorePortalEleMap[exposeStat];
      }
    }
  }, {
    key: 'initBindElementExplore',
    value: function initBindElementExplore() {
      var _this4 = this;

      window.setTimeout(function () {
        $('[ag-expose]').each(function (index, e) {
          var isXlyxTemplate = $(e).attr('type') === 'template' ? true : false;
          if (isXlyxTemplate) return;
          var exposeStat = $(e).attr('ag-expose');
          var stat = _this4.handleStat(exposeStat, 'expose');
          _this4.ExplorePortalEleMap[exposeStat] = {
            stat: stat
          };
        });
        _this4.doExploreV2();
        _this4.bindScrollEvent();
      }, 1000);
    }
  }, {
    key: 'addRecommendExplorePortalEleMap',
    value: function addRecommendExplorePortalEleMap(ele) {
      var _this5 = this;

      if (ele.length === 0) {
        return;
      }
      var exposeStat = $(ele).attr('ag-expose');
      if (!exposeStat) {
        return;
      }
      setTimeout(function () {
        var stat = _this5.handleStat(exposeStat, 'expose');
        _this5.ExplorePortalEleMap[exposeStat] = {
          stat: stat
        };
      }, 0);
    }
  }, {
    key: 'bindScrollEvent',
    value: function bindScrollEvent() {
      var _this6 = this;

      if (window.location.host.indexOf('www.9game.cn') > -1) {
        this.scrollListener[0].addEventListener('scroll', throttle(function (e) {
          _this6.doExploreV2();
        }), false);
      } else {
        this.scrollListener.on('scroll', throttle(function (e) {
          _this6.doExploreV2();
        }), false);
      }
    }
  }, {
    key: 'initBindElementClick',
    value: function initBindElementClick() {
      this.addCustomClick($('[ag-click],[ag-down],[ag-qdown]'));
    }
  }, {
    key: 'addCustomClick',
    value: function addCustomClick(targets) {
      var _this7 = this;

      window.setTimeout(function () {
        $(targets).each(function (i, ele) {
          $(ele).on('click', debounce(function () {
            var clickTypeStatInfo = $(ele).attr('ag-click');
            var downTypeStatInfo = $(ele).attr('ag-down');
            var qdownTypeStatInfo = $(ele).attr('ag-qdown');
            var type = '';
            var statInfo = '';
            if (clickTypeStatInfo) {
              type = 'click';
              statInfo = clickTypeStatInfo;
            } else if (downTypeStatInfo) {
              type = 'down';
              statInfo = downTypeStatInfo;
            } else if (qdownTypeStatInfo) {
              type = 'quick_down';
              statInfo = qdownTypeStatInfo;
            }
            if (!statInfo) return;
            var stat = _this7.handleStat(statInfo, type);
            _this7.StatPortal(stat);
          }));
        });
      }, 0);
    }
  }, {
    key: 'IsSpider',
    value: function IsSpider() {
      return !!window.navigator.userAgent.toLowerCase().match('spider') || !!window.navigator.userAgent.toLowerCase().match('bot');
    }
  }, {
    key: 'SendToPortal',
    value: function SendToPortal(stat) {
      var _this8 = this;

      if (this.IsSpider()) return;
      if (typeof $ === 'undefined') {
        console.warn('[SendToPortal]:缺少"$"依赖,ajax上报门户失败');
        return;
      }

      window.setTimeout(function () {
        $.ajax({
          type: 'POST',
          url: _this8.sendPortalAdUrl,
          data: stat,
          timeout: 4000,
          success: function success(data) {},
          error: function error(err) {}
        });
      }, 0);
    }
  }, {
    key: 'createPageStat',
    value: function createPageStat(obj, type) {
      var _this9 = this;

      if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
        return;
      }
      obj = _extends({}, this.basestatinfo, obj);
      var stat = '';
      Object.keys(obj).forEach(function (key, idx) {
        if (_this9.KEY_WHITELIST.includes(key)) {
          if (idx == 0) {
            stat += key + ':' + obj[key];
          } else {
            stat += ';' + key + ':' + obj[key];
          }
        }
      });
      if (type === 'expose') {
        return 'ag-expose="' + stat + '"';
      } else if (type === 'click') {
        return 'ag-click="' + stat + '"';
      } else if (type === 'quick_down') {
        return 'ag-qdown="' + stat + '"';
      } else if (type === 'down') {
        return 'ag-down="' + stat + '"';
      }
    }
  }, {
    key: 'scrollDOM',
    set: function set($DOM) {
      this.scrollListener = typeof $DOM === 'string' ? $($DOM) : $DOM;
      this.bindScrollEvent();
    }
  }]);

  return AgStat;
}();

module.exports = AgStat;

/***/ }),

/***/ "AE1G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var Popover = function Popover(options) {

  this.container = options.container ? options.container : '#ad-popover';
  this.to = options.to ? options.to : '';
  this.width = $(window).width();
  this.height = $(window).height();
  this.time = options.time ? options.time : 3;
  this.etagType = options.etagType ? options.etagType : 'day';
  this.etag = options.etag ? options.etag : 1;
};

Popover.prototype = {
  init: function init() {

    if (!this.expires(this.etag)) return;

    var alias = this;
    $(this.container).show();
    $(this.container + '-bg').show();

    if ($(this.to).length > 0) {
      this.width = $(this.to).offset().left + parseInt($(this.to).width() / 2);
      this.height = $(this.to).offset().top + parseInt($(this.to).height() / 2);
    }

    setTimeout(function () {
      alias.ani(alias.height, alias.width);
    }, this.time * 1000);

    $(this.container + ' .close').on('click', function () {
      alias.ani(alias.height, alias.width);
    });
  },
  ani: function ani(h, w) {
    $(this.container).animate({
      opacity: 0,
      width: 0,
      top: h,
      left: w
    });
    $(this.container + '-bg').hide();
  },
  expires: function expires(day) {
    var show = true;

    if (window.localStorage) {
      var _oldExpires = parseInt(localStorage.getItem('popover-expires'));
      if (_oldExpires) {
        var _newExpires = new Date().getTime();
        var _diff = _newExpires - _oldExpires;
        var _condition = day * 24 * 60 * 60 * 1000;
        if (this.etagType != 'day') _condition = day * 1000;

        if (_diff < _condition) show = false;else window.localStorage.setItem('popover-expires', _newExpires);
      } else {
        window.localStorage.setItem('popover-expires', new Date().getTime());
      }
    }

    return show;
  }
};

module.exports = Popover;

/***/ }),

/***/ "Byvx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var scrollBottomLoad = {

  init: function init(arg) {
    var that = this;
    that.requestIng = false;
    that.data = arg.data;
    that.url = arg.url;
    that.type = arg.type || "GET";
    that.unbindScroll = false;
    that._getDom(arg);
    if (that.container.size() == 0) {
      return;
    }
    that._getFun(arg);
    arg.initFun();
    that._bind(arg);
    $(window).trigger("scroll");
    that.loadingTipNum = arg.loadingTipNum || '';
    arg.initScroll = arg.initScroll || '';
    arg.scrollHeight = arg.scrollHeight || 400;
    arg.scrollLoad = arg.scrollLoad || '';
  },

  _getDom: function _getDom(arg) {
    var that = this;
    var doc = document;
    that.container = $("#" + arg.containerId);
    that.loadingTipObj = $("#" + arg.loadingTipObjId);
    that.loadingTipHtml = that.loadingTipObj.html();
    that.loadErrorTipHtml = $("#" + arg.loadErrorTipObjId).html();
    that.loadMoreTipHtml = $("#" + arg.loadMoreTipObjId).html();
    that.noMoreTipHtml = $("#" + arg.noMoreTipObjId).html();
    that.loadParentBoxId = $("#" + arg.loadParentBoxId);
    that.list_loading = $("#" + arg.list_loading);
    that.loadif = that.list_loading.length;
  },

  _getFun: function _getFun(arg) {
    var that = this;
    that.initFun = arg.initFun || function () {};
    that.startFun = arg.startFun || function () {};
    that.errorFun = arg.errorFun || function () {};
    that.endFun = arg.endFun || function () {};
    that.successFun = arg.endFun || function () {};
  },

  _bind: function _bind(arg) {
    var that = this;
    that._bindScroll(arg);
    $("#" + arg.list_loading).off().on('click', function () {
      that._request(arg);
    });
  },

  _bindScroll: function _bindScroll(arg) {
    var that = this;

    if (arg.scrollLoad) {
      that._successFun('', arg);
    }

    if (arg.initScroll) {
      that._request(arg);
    }

    $(window).bind('scroll', function () {
      if (arg.scrollLoad) return;
      if (!that.unbindScroll) {
        if ($(window).scrollTop() >= $(document).height() - $(window).height() - arg.scrollHeight) {
          that._request(arg);
        }
      }
    });
  },

  _request: function _request(arg) {
    var that = this;
    if (that.requestIng == false) {
      that._ajax(arg);
    }
  },

  _render: function _render(data, arg) {
    var that = this;
    $("#" + arg.containerId).append(data);
    $(window).trigger("scroll");
  },

  _beforeSendFun: function _beforeSendFun(arg) {
    var that = this;
    that.requestIng = true;
    $("#" + arg.loadingTipObjId).html($("#" + arg.loadingTipObjId).html());
    that.startFun();
  },

  _successFun: function _successFun(data, arg) {
    var that = this;
    that.requestIng = false;
    var continueTo = arg.endFun(data);
    if (continueTo == "noMore") {
      that.unbindScroll = true;
      $("#" + arg.loadingTipObjId).html($("#" + arg.noMoreTipObjId).html());
      that._hideload(arg);
    } else if (continueTo == "clickMore") {
      that.unbindScroll = true;
      that._render(data, arg);
      $("#" + arg.loadingTipObjId).html($("#" + arg.loadMoreTipObjId).html());
    } else if (continueTo == "resumeAutoLoad") {
      that._bindScroll(arg);
      that._render(data, arg);
      $("#" + arg.loadingTipObjId).html($("#" + arg.loadingTipObjId).html());
    } else if (continueTo == "againRequest") {
      that.unbindScroll = true;
      $("#" + arg.loadingTipObjId).html($("#" + arg.loadingTipObjId).html());
    } else if (continueTo == "temporarilyNoMore") {
      $("#" + arg.loadingTipObjId).html($("#" + arg.noMoreTipObjId).html());

      that.unbindScroll = true;
      that.times = setTimeout(function () {
        $("#" + arg.loadParentBoxId).hide();
      }, 3000);
    } else {
      that._render(data, arg);
      $("#" + arg.loadingTipObjId).html($("#" + arg.loadingTipObjId).html());
    }
  },

  _errorFun: function _errorFun(arg) {
    var that = this;
    that.requestIng = false;
    that.errorFun();
    $("#" + arg.loadingTipObjId).html($("#" + arg.loadErrorTipObjId).html());
  },

  _showload: function _showload(arg) {
    var that = this;
    if (that.loadif > 0) {
      $("#" + arg.list_loading).show();
      $("#" + arg.list_loading).find("#loadingTip" + that.loadingTipNum + "").show();
    }
  },

  _hideload: function _hideload(arg) {
    var that = this;
    if (that.loadif > 0) {
      that.times = setTimeout(function () {
        $("#" + arg.list_loading).hide();
      }, 1000);
    }
  },

  _ajax: function _ajax(arg) {
    var that = this;
    var dataSet = that.setData(arg.data);
    var urlSet = that.setUrl(arg.url);
    $.ajax({
      type: arg.type,
      url: urlSet,
      data: dataSet,
      timeout: 4000,
      beforeSend: function beforeSend() {
        that._beforeSendFun(arg);
        that._showload(arg);
      },
      success: function success(data) {
        that._successFun(data, arg);
        that._showload(arg);
        var params = JSON.parse(JSON.stringify(arg.data));
        arg.successFun(params);
      },
      error: function error() {
        that._errorFun(arg);
      }
    });
  },

  setData: function setData(data) {
    var that = this;

    return data;
  },

  setUrl: function setUrl(url) {
    var that = this;

    return url;
  }

};

module.exports = scrollBottomLoad;

/***/ }),

/***/ "GgL9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var example = $('[type=template]');
var xlyx = $('[type=xlyx]');
var xlyx_tem = $('.xlyx_template');
var reqUrl = $('#recommendUrl').val() || '//a.9game.cn/recommend/queryv2/';
var gameList = '[type=xlyx-count-item]';
var list_item_num = 4;
var forMainReg = /@for=\d+@[\s\S]+?@endfor@/;

var Module = function () {
  function Module() {
    _classCallCheck(this, Module);

    this._callback = function () {};
    this.init();
  }

  _createClass(Module, [{
    key: 'init',
    value: function init() {
      var that = this;

      xlyx_tem.hide();

      example.each(function () {
        var template = $(this);
        var params = template.data('params') || {};
        params.scenarioId = $(this).data('scenarioId');
        params.isFinishRealName = true;
        ajaxInfo({
          data: params,
          callback: function callback(result) {
            if (result.data) {
              var size = result.data.items && result.data.items.length;
              var hideMore = false;
              if (size < 2) {
                template.hide();
              } else {
                var datas = [];
                for (var i = 0; i < result.data.items.length; i++) {
                  var temp = result.data.items[i];
                  for (var j in temp) {
                    if (Object.prototype.toString.call(temp[j]).toLocaleLowerCase() == '[object string]') {
                      temp[j] = temp[j].replace('http://', 'https://');
                    }
                  }
                  if (temp.downloadStatus == 1) {
                    temp.downUrl = temp.zoneUrl;
                  }
                  datas.push(temp);
                }
                var html = template.html();
                var totalReg = /@total@/;
                html = html.replace(totalReg, size);

                var _html = templateToHtml(datas, html);
                html = html.replace(forMainReg, _html);
                template.html(html).show();
                size < 5 ? template.find('.more1').hide() : '';
                if (html && window.GLOBAL_AgStat) {
                  window.GLOBAL_AgStat.addRecommendExplorePortalEleMap(template);
                  window.GLOBAL_AgStat.addRecommendClick(template);
                }
              }
            }
          }
        });
      });

      $(document).on('click', '.game-recommend-download', function () {
        var _html = void 0;
        var data = void 0;
        var _this = $(this);
        var item = $(this).closest(gameList);
        var itemId = item.data('gameId') || _this.data('gameId');
        var game_name = item.data('gameName') || _this.data('gameName');
        var idx = Math.ceil(item.data('idx') / list_item_num);

        var xlyx_template = item.next('.xlyx_template');
        var position = item.siblings('[type=xlyx]').eq(idx - 1);
        var swiper_xlyx = item.closest('.swiper-wrapper');
        var swiper_xlyx_position = swiper_xlyx.length ? swiper_xlyx.siblings('[type=xlyx]') : false;

        xlyx_template.length === 0 ? xlyx_template = $('.xlyx_template') : '';
        _html = item.siblings('.xlyx_template').html() ? item.siblings('.xlyx_template').html() : xlyx_template.html();

        var gameNameReg = /@gamename@/;
        var formDownIdReg = /@fromDownId@/;
        _html = _html.replace(gameNameReg, game_name);
        _html = _html.replace(formDownIdReg, item.data('gameId'));

        data = {
          scenarioId: xlyx_template.data('scenarioId'),
          itemId: itemId,
          isFinishRealName: true };

        ajaxInfo({
          data: data,
          callback: function callback(result) {
            var items = result.data.items;
            if (items.length > 0) {
              var datas = [];
              for (var i = 0; i < items.length; i++) {
                var temp = items[i];
                for (var j in temp) {
                  if (Object.prototype.toString.call(temp[j]).toLocaleLowerCase() == '[object string]') {
                    temp[j] = temp[j].replace('http://', 'https://');
                  }
                }
                if (temp.downloadStatus == 1) {
                  temp.downUrl = temp.zoneUrl;
                }
                datas.push(temp);
              }
              var html = templateToHtml(datas, _html);
              _html = _html.replace(forMainReg, html);

              if (position.length) {
                xlyx.empty().hide();
                position.html(_html).show();
              } else if (swiper_xlyx.length) {
                xlyx.empty().hide();
                swiper_xlyx_position.html(_html).show();
              } else {
                _this.closest(gameList).siblings('.game-recommend').each(function () {
                  if ($(this).css('display') !== 'none') {
                    $(this).remove();
                  }
                });
                _this.closest(gameList).after(_html);
              }

              if (window.countFunc) {
                countFunc.count_show();
              }
            }
          }
        });
      });

      function templateToHtml(info, template, item) {
        var replaceReg = /@(\w+)@/g;
        var forReg = /@for=(\d+)@([\S\s]*?)@endfor@/;
        var str = '';

        var match = template.match(forReg);
        if (!match) return;
        var size = match[1];
        var forList = match[2];

        info.forEach(function (item, i) {
          item.idx = i + 1;
          if (!item.src) {
            item.src = 'src';
          }
        });

        info.slice(0, size).map(function (item, i) {
          var temp = forList.replace(replaceReg, function (match, $1) {
            return item[$1];
          });

          if (item.downloadStatus == 1) {
            temp = temp.replace('下载', '详情');
          }
          str += temp;
        });
        str = str.replace(/data-tep-href=/g, 'href=');
        return str;
      }

      function ajaxInfo(arg) {
        if (arg.data) {
          arg.data.identify = $('#realNameIdentify').data('identify');
        }
        $.ajax({
          type: arg.type || 'POST',
          url: reqUrl,
          data: arg.data,
          timeout: 4000,
          success: function success(result) {
            arg.callback(result);
            that._callback();
          },
          error: function error(err) {
            console.log('request error!');
          }
        });
      }
    }
  }, {
    key: 'callback',
    set: function set(func) {
      this._callback = func;
    }
  }]);

  return Module;
}();

module.exports = new Module();

/***/ }),

/***/ "cRQd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function inWeiXin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") return true;else return false;
}
if (inWeiXin()) {
  $('.body-content').on('touchstart', function (event) {
    var parentName = ['dl.quality-game', 'dl.recommend', 'div.subject', 'dl.billboard', 'dl.guess', '.bt-warp'];
    var isDown = false;
    parentName.forEach(function (v, i) {
      if ($(event.target).attr('type') == 'btn' && $(event.target).closest(parentName[i]).length > 0 && !$(event.target).hasClass('undown')) {
        isDown = true;
      }
    });
    if (isDown) {
      $('#popWechat').show();
      event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }
  });
}
$('#popWechat').click(function () {
  $(this).hide();
});

/***/ }),

/***/ "gGJ/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function () {
  function Module() {
    _classCallCheck(this, Module);

    this.Loading = this._Loading;
    this.cover = this._cover;
    this.root = $('body');
    this.root.before(this.cover);
  }

  _createClass(Module, [{
    key: 'createImgElement',
    value: function createImgElement(url) {
      var _this = this;

      var img = new Image();
      var that = this;
      this.cover.append(this.Loading);
      img.onload = function () {
        that.Loading.remove();
        var windowHeight = window.innerHeight;
        var windowWidth = window.innerWidth;
        var currentHeight = this.height / (this.width / windowWidth);
        var marginTop = (windowHeight - currentHeight) / 2;
        var divStyle = "style='height:100%;width:100%;'";
        var imgStyle = 'style=\'position:relative;top:' + marginTop + 'px;width:100%;display:block;\'';
        var $ele = $('<div ' + divStyle + ' class="m-show-media-cover-img"><img class="cover-img" ' + imgStyle + ' src="' + url + '"></div>');
        that.cover.append($ele);
      };
      img.src = url;
      this.cover.on('click', function (e) {
        _this.cover.toggle(false);
        $('.m-show-media-cover-img').remove();
        _this.cover.off();
      });
    }
  }, {
    key: 'createVideoElement',
    value: function createVideoElement(url) {
      var _this2 = this;

      var style = 'style="margin-top:50%"';
      var closeStyle = 'style="margin:0 auto;height:32px;width:32px;margin-top:10%;background:url(data:image/png;base64,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) no-repeat;background-size:cover;"';
      var videoStyle = 'style="height:auto;width:100%"';
      var $ele = $('<div class="m-show-media-cover-video" ' + style + ' ><video controls autoplay="autoplay" src=\'' + url + '\' ' + videoStyle + ' /></div>');
      var $close = $('<div class="m-show-media-cover-video-close" ' + closeStyle + ' ></div>');
      this.cover.append($ele);
      this.cover.append($close);
      $close.on('click', function (e) {
        _this2.cover.toggle(false);
        _this2.cover.text('');
        $close.off();
      });
    }
  }, {
    key: 'CreateElement',
    value: function CreateElement(type, url) {
      if (type === 'img') {
        this.$ele = this.createImgElement(url);
      } else if (type === 'video') {
        this.$ele = this.createVideoElement(url);
      }
    }
  }, {
    key: 'ToggleCover',
    value: function ToggleCover(type, url, callback) {
      if (!type || !url) return;
      this.cover.toggle(true);
      this.CreateElement(type, url);
      if (!callback) return;
      callback(this.cover);
    }
  }, {
    key: '_Loading',
    get: function get() {
      var LoadingBase64 = 'data:image/gif;base64,R0lGODlhDwAPAPQAAJWVlaqqqr+/v9XV1dnZ2bKyssXFxZ+fn6CgoOHh4efn583NzbOzs97e3u/v7/X19eXl5cbGxu3t7aurq+rq6vPz87y8vAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUP8/eHBhY2tldCBiZWdpbj0i72lkOjQzREFENjZENuHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBRQAEAAsAAAAAA8ADwAABULg0wwkCQkoujhEWZ4parhvnNKmjeIDbPO+GFAngBiPyCRgyQRAAtBooMl8SqHUpfWadV6x2a0UEf4yEgeqOFBQhAAAIfkEBRQACAAsAAAAAA8ADwAABUIgNAEkiQwo2jxHWZ4pSrhvnNKmjeIAbPO+GFA3QBiPyGRgyQwgBNCooMl8SqHUpfWadV6x2a2UEf5GFAWqWGCQhAAAIfkEBRQACAAsAAAAAA8ADwAABUIgZQUkiQAoOkFFWZ4perhvnNKmjeIBbPO+GFAHQBiPyKRgyRQgBtDooMl8SqHUpfWadV6x2a00Ev4SJAaqeECohAAAIfkEBRQACgAsAAAAAA8ADwAABUKgswgkqQQoalFGWZ4pWrhvnNKmjeICbPO+GFAXUBiPyORgyRwoANAooMl8SqHUpfWadV6x2a2UEP4iKuSmGHBIhAAAOw==';
      var style = "style='height:15px;width:15px;margin:50% auto;'";
      return $('<div ' + style + ' class="m-show-media-cover-loading"><img src="' + LoadingBase64 + '"></div>');
    }
  }, {
    key: '_cover',
    get: function get() {
      var style = 'style="display:none;z-index:1000;height:100%;width:100%;position:fixed;background:rgba(0, 0, 0, 0.72);"';
      var $cover = $('<div class="m-show-media-cover" ' + style + ' ></div>');
      return $cover;
    }
  }]);

  return Module;
}();

module.exports = new Module();

/***/ }),

/***/ "jChq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kORv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function () {
  function Module() {
    _classCallCheck(this, Module);

    this.ShowMedia = __webpack_require__("gGJ/");
    this.isbd = parseInt($('#_isbd').val(), 10);
    this.Init();
  }

  _createClass(Module, [{
    key: 'Init',
    value: function Init() {
      this.BindCardEvent();
    }
  }, {
    key: 'createCardImgs',
    value: function createCardImgs(obj) {
      if (obj.cardType === 'single') {
        return '<img class="img show lazy" dataimg="' + obj.gameImgs[0] + '" src="https://image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif" alt="' + obj.gameName + '\u622A\u56FE">';
      } else if (obj.cardType === 'horizontal' || obj.cardType === 'vertical') {
        var arrImg = obj.gameImgs.map(function (e, idx) {
          return '<li class="item"><img class="lazy img show" dataimg="' + e + '" src="https://image.9game.cn/s/uae/g/0h/portal/image/lazy2.gif" alt="' + obj.gameName + '\u622A\u56FE' + idx + '"></li>';
        });
        return '<ul class="game-imgs">' + arrImg.join('') + '</ul>';
      }
    }
  }, {
    key: 'createCardIntro',
    value: function createCardIntro(obj) {
      if (obj.gameKeywords.length > 0) {
        var arrKeys = obj.gameKeywords.map(function (e, idx) {
          if (obj.gameKeywordsUrl.length > 0 && obj.gameKeywordsUrl[idx]) {
            return '<a href="' + obj.gameKeywordsUrl[idx] + '" title="' + e + '" class="tag">' + e + '</a>';
          } else {
            return '<span class="tag">' + e + '</span>';
          }
        }).slice(0, 3);
        return '<div class="game-tags">' + arrKeys.join('') + '</div>';
      } else {
        var createCategory = function createCategory() {
          if (obj.gameCategoryUrl) {
            return '<a href="' + obj.gameCategoryUrl + '" title="' + obj.gameCategory + '">' + obj.gameCategory + '</a>';
          } else {
            return '<span title="' + obj.gameCategory + '">' + obj.gameCategory + '</span>';
          }
        };
        if (obj.gameSize) {
          return '<div class="game-intro">\n       ' + createCategory() + '&nbsp;|&nbsp;' + obj.gameSize + '\n      </div>';
        } else {
          return '<div class="game-intro">' + createCategory() + '</div>';
        }
      }
    }
  }, {
    key: 'createCard',
    value: function createCard(obj) {
      var _this = this;

      var sidEndChar = '' + $('#sidEndChar').val();
      var createScore = function createScore() {
        var score = '5.2';
        if (obj.gameScore !== '') {
          score = obj.gameScore;
        }
        return '<div class="game-score">' + score + '</div>';
      };
      var createDesc = function createDesc() {
        if (obj.gameDesc) {
          return '<div class="game-desc limit">\n        ' + obj.gameDesc + '\n        <a href="' + obj.zoneHref + '" class="more">\u5168\u90E8</a>\n      </div>';
        } else {
          return '';
        }
      };
      var createDown = function createDown() {
        if (_this.isbd === 1) {
          if (obj.gameUrl.indexOf('game/downs_') > -1) {
            return '<div class="game-down game-btn download JS_bd_down" data-more="1" data-url="' + obj.gameUrl + '" data-game-id="' + obj.gameId + '" data-ishigh="1">\u9AD8\u901F\u4E0B\u8F7D</div>\n          <div class="download-select JS_bd_toggle" data-more="1">\n            <div class="select-btn select"></div>\n            <div class="text">\u7528\u4E5D\u6E38App\u4E0B\u8F7D</div>\n          </div>';
          } else {
            return '<div class="game-down game-btn download JS_ng_down" data-more="1" data-game-id="' + obj.gameId + '">\u9884\u7EA6</div><div class="game-tips">\u4F7F\u7528\u4E5D\u6E38APP\u9884\u7EA6</div>';
          }
        } else {
          return '<div class="game-down game-btn download game-recommend-download JS_ng_down" data-more="1" data-game-id="' + obj.gameId + '">\u4E0B\u8F7D</div><div class="game-tips">' + obj.gameAbstract + '</div>';
        }
      };
      return '<div class="main-game-item two ' + obj.cardType + '" type="xlyx-count-item" data-game-id="' + obj.gameId + '" data-game-name="' + obj.gameName + '">\n        <div class="game-imgs-box">\n          ' + this.createCardImgs(obj) + '\n        </div>\n        <div class="game-main">\n          <div class="game-basic">\n            <a href="' + obj.zoneHref + '" class="game-icon">\n              <img class="img lazy" dataimg="' + obj.gameIcon + '" src="https://image.9game.cn/s/uae/g/0n/static/ngm-portal/public/img/lazy2.9b2f125e.gif" alt="' + obj.gameName + '">\n            </a>\n            <div class="game-info">\n              <a class="game-tit" href="' + obj.zoneHref + '" title="' + obj.gameName + '">\n                ' + obj.gameName + '\n              </a>\n              ' + this.createCardIntro(obj) + '\n            </div>\n          </div>\n          ' + createScore() + '\n        </div>\n        ' + createDesc() + '\n        ' + createDown() + '\n      </div>';
    }
  }, {
    key: 'AppendCards',
    value: function AppendCards(arr, callback) {
      var _this2 = this;

      var result = arr.map(function (v, index) {
        return _this2.createCard(v);
      });
      callback ? callback(result.join('')) : '';
      this.BindCardEvent();
    }
  }, {
    key: 'BindCardEvent',
    value: function BindCardEvent() {
      var _this3 = this;

      $('.main-game-theme').find('img.show').off('click', function (e) {
        _this3.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
      });
      $('.main-game-theme').find('img.show').on('click', function (e) {
        _this3.ShowMedia.ToggleCover('img', $(e.target).attr('src'));
      });
    }
  }]);

  return Module;
}();

module.exports = new Module();

/***/ }),

/***/ "vIqV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var scrollBottomLoad = __webpack_require__("Byvx");
var nowDate = -1,
    typeParam = $("#param").val() ? JSON.parse($("#param").val()) : {},
    sUrl = $("#param").attr("data-url");

typeParam.isajax = 1;
typeParam.beginIndex = typeParam.beginIndex || 0;
typeParam.count = typeParam.count || 6;

var clickMorePageNum = typeof typeParam.clickMorePageNum === 'number' ? typeParam.clickMorePageNum : 3;
var numberOfRequests = 0;
function initFunction() {
  $(window).trigger("scroll");
  scrollBottomLoad.setData(typeParam);
}
function endFunction(dataHtml) {
  if (clickMorePageNum === 0) {
    typeParam.beginIndex = typeParam.beginIndex + typeParam.count;
    return "clickMore";
  }
  var dataHtml = $.trim(dataHtml);
  if (dataHtml == "") {
    return "noMore";
  } else {
    typeParam.beginIndex = typeParam.beginIndex + typeParam.count;
    scrollBottomLoad.setData(typeParam);
  }
  numberOfRequests++;
  if (numberOfRequests % clickMorePageNum == 0) {
    return "clickMore";
  } else if (numberOfRequests % clickMorePageNum == 1) {
    return "resumeAutoLoad";
  }
}

module.exports = function (successFun, args) {
  var func = function func() {};
  var args = args || {};
  if (successFun) {
    func = successFun;
  }
  if (clickMorePageNum === 0) {
    args.scrollLoad = true;
    args.initScroll = false;
  }
  var defaultArgs = {
    url: sUrl,
    type: "GET",
    data: typeParam,
    loadingTipObjId: "loadingTip",
    loadErrorTipObjId: "errorTip",
    loadMoreTipObjId: "moreBtn",
    noMoreTipObjId: "noMoreTip",
    containerId: "ajaxContainer",
    list_loading: 'list_loading',
    initScroll: true,
    initFun: initFunction,
    endFun: endFunction,
    successFun: func
  };
  _extends(defaultArgs, args);
  scrollBottomLoad.init(defaultArgs);
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/hotwords/index/index.b8d8fc31.js